import { SaveTechnologyTemplate } from '../saveTechnologyTemplate';
import { CandidateEvaluationFeedback } from '../candidateEvaluationFeedback';

export class saveTechnologyTemplateSerializer {
    fromJson(json: any): CandidateEvaluationFeedback {
        return json;
    }
    toJson(json: CandidateEvaluationFeedback): SaveTechnologyTemplate {
        return json;
    }

}